import { defineComponent, openBlock, createElementBlock, createElementVNode } from 'vue';
import _export_sfc from './_virtual/plugin-vue_export-helper.mjs';

const _sfc_main = defineComponent({
  name: "Huanyihuan"
});
const _hoisted_1 = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2 = /* @__PURE__ */ createElementVNode("path", {
  d: "M2.6665 2L7.99984 2",
  stroke: "#5587FF",
  "stroke-width": "1.33",
  "stroke-linecap": "square"
}, null, -1);
const _hoisted_3 = /* @__PURE__ */ createElementVNode("path", {
  d: "M8 14L13.3333 14",
  stroke: "#5587FF",
  "stroke-width": "1.33",
  "stroke-linecap": "square"
}, null, -1);
const _hoisted_4 = /* @__PURE__ */ createElementVNode("path", {
  d: "M8 2C4.6863 2 2 4.6863 2 8C2 9.69517 2.70299 11.2261 3.83333 12.3173M8 14C11.3137 14 14 11.3137 14 8C14 6.38147 13.3591 4.9126 12.3173 3.83333",
  stroke: "#5587FF",
  "stroke-width": "1.33",
  "stroke-linecap": "square"
}, null, -1);
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _hoisted_5);
}
var huanyihuan = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);

export { huanyihuan as default };
